import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import "./uploadMain.css";
import Breadcrumb from "@/components/bread-crumb/BreadCrumb";

const UploadMain = () => {
  return (
    <article className="page-container">
      <div className="card-container">
   <div>
                        <Breadcrumb
                            items={[
                                { label: 'Home', path: '/' },
                                { label: 'Upload Signature', path: '/upload-signature' }
                            ]}
                        />
                    </div>
        <div className="card-header">
          <h2>Upload Utility</h2>
          <p className="subtitle">
            Choose an option below to upload <strong>Signatures</strong> or <strong>Stamps</strong>.
          </p>
        </div>

        <div className="card-section">
          <h3 className="section-title">Upload Options</h3>

          <div className="tab-row">
            <NavLink
              end
              to="search"
              className={({ isActive }) =>
                `tab-base ${isActive ? "tab-active" : "tab-inactive"}`
              }
            >
              Upload Signatures
            </NavLink>

            <NavLink
              end
              to="stamps"
              className={({ isActive }) =>
                `tab-base ${isActive ? "tab-active" : "tab-inactive"}`
              }
            >
              Upload Stamps
            </NavLink>
          </div>
        </div>

        <div className="card-section content-area">
          <Outlet />
        </div>

      </div>
    </article>
  );
};

export default UploadMain;